<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Blog Posts' : 'Deleted Blog Posts'"
              ></h3>
              <v-btn v-can:add="'blogs'"
                class="mx-2 mb-2 hover-primary"
                fab
                x-small
                color="primary"
                to="/blogs/create"
              >
                <v-icon dark> mdi-plus </v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    hide-details="auto"
                    rounded
                    @click:clear="(filter.is_active = null), (page = 1)"
                    v-model="filter.is_active"
                    :items="statuses"
                    label="Status"
                    @input="(page = 1), getData()"
                    placeholder="Filter by Active Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: 130px">Title</th>
                      <th class="text-center" style="min-width: 115px">
                        Image
                      </th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="blogs.length != 0">
                    <tr
                      v-for="(blog, i) in blogs"
                      :key="`blog_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': blogs.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <td>
                        <v-tooltip bottom v-if="blog.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>User is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="blog.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>User is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>{{ blog.title || "" }}</td>
                      <td style="min-width: 115px">
                        <v-img
                          :src="`${mediaUrl + blog.imagepath}`"
                          alt="Blog"
                          class="mx-auto"
                          width="80"
                          height="80"
                        ></v-img>
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(blog.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 155px">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              class="ml-2"
                              fab
                              x-small
                              color="primary"
                              :to="`/blogs/${encryptIt(blog.id)}/blog-details`"
                            >
                              <v-icon dark> mdi-eye </v-icon>
                            </v-btn>
                          </template>
                          <span>View Blog Details</span>
                        </v-tooltip>
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'blogs'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="OpenWarning(blog.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Request</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/blogs/${encryptIt(blog.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Blog</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'blogs'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(blog.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this blog</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Status Change Warning Dialog Box -->
      <v-dialog v-model="show_Warning_popUp" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>
                        Are you sure to
                        {{
                          selected_requested.status == "1"
                            ? "Approve"
                            : "Reject"
                        }}?.
                      </h3>
                      <br />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-btn v-can:edit="'blogs'"
                        color="success"
                        @click="
                          (show_Warning_popUp = false),
                            confirmUpdate(selected_requested)
                        "
                      >
                        Confirm
                      </v-btn>
                    </v-col>
                    <v-col>
                      <v-btn
                        color="red"
                        dark
                        @click="
                          (show_Warning_popUp = false),
                            (selected_requested = {})
                        "
                      >
                        Cancel
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Delete Warning Dialog Box -->
      <v-dialog v-model="deleteDialog" width="550px">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 150px"
                >
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="red"
                        dark
                        class="ml-5"
                        @click="
                          Delete_this(to_be_deleted_id), (deleteDialog = false)
                        "
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_blog" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Request deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_blog = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_restored_blog" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>DaycareCareerRequest restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_blog = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "BlogsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        show_deleted: false,
      },
      blogs: [],
      statuses: [
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      ExportDaycareCareerRequestTypes: [],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
      },
      isLoading: false,
      isExcelloading: false,
      delete_blog: false,
      is_deleted_blog: false,
      restore_blog: false,
      is_restored_blog: false,
      show_Warning_popUp: false,
      pendingRequestId: "",
      is_confirmed_delete: "",
      to_be_deleted_id: "",
      deleteDialog: "",
      selected_requested: {},
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        const pad = (n) => String(n).padStart(2, "0");
        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear();
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        return value;
      }
    },
    OpenWarning(request_id) {
      console.log("Show Warning");
      this.is_confirmed_delete = false;
      this.to_be_deleted_id = request_id;
      this.deleteDialog = true;
    },
    updateStatus(id, status) {
      this.selected_requested = {
        id: id,
        status: status,
      };
      this.show_Warning_popUp = true;
    },
    async confirmUpdate(selected_requested) {
      let reqID = this.encryptIt(selected_requested.id);

      await axios.patch(`/blogs/${reqID}`, selected_requested).then(() => {
        this.getData();
      });
      this.show_Warning_popUp = false;
    },
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`blogs?${query}`)
        .then((response) => {
          this.blogs = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch((error) => {
          console.error(error);
          this.isUnAuthorised();
        });
      this.isLoading = false;
    },
    //Generate Excel
    async generateExcel() {
      let query = "search_keyword=" + this.filter.search_keyword;
      let response = await axios.get(`blog_exports?${query}`);
      console.log(response.data.data);
      if (response) {
        window.open(`${response.data.data}`, "_blank");
      }
    },
    async Delete_this(id) {
      this.delete_blog = true;
      await axios
        .post(`/blogs/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_blog = false;
          this.is_deleted_blog = true;
          this.getData();
        })
        .catch((error) => {
          console.error(error);
          // this.isUnAuthorised();
        });
    },
    async Restore_this(id) {
      this.restore_blog = true;
      await axios
        .post(`/blogs/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_blog = false;
          this.is_restored_blog = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
          window.location.href = "/auth/login";
        });
    },
  },
};
</script>
